import { store } from '@app/state/store';
import {
  EReportPeriod,
  getDatesByReportPeriodCore,
} from '@westondev/tableturn-core';

export const getDatesByReportPeriod = (period: EReportPeriod) =>
  getDatesByReportPeriodCore(period, store.getState());
